import { Flex, FormConfigurationProvider, ModelDateDMY } from '@equifinance/shared';
import styled from 'styled-components';
import { CollapsibleHeaderCss } from '../Commercials';
import { PaddedSection } from '../../../Account/components/Section';

export const AnnualReviewRefName = 'annual-review-section';

const AnnualReviewContainer = styled(Flex)`${({ theme }) => `
  width: 30%;
  margin-left: ${theme.padding[11]}; 
`}`;

export function AnnualReviewSection() {
  return (
    <PaddedSection
      id={AnnualReviewRefName}
      refName={AnnualReviewRefName}
      title="Annual Review"
      headerCss={CollapsibleHeaderCss}
      isLocked
    >
      <FormConfigurationProvider isReadOnlyInput>
        <AnnualReviewContainer>
          <ModelDateDMY
            label="Annual review date"
            field="nextAnnualReviewDate"
            showDay
            required
          />
        </AnnualReviewContainer>
      </FormConfigurationProvider>
    </PaddedSection>
  );
}
